import {combineReducers} from 'redux'
import notariaReducer from './notariaReducer'
import auth from './authReducer'
import configReducer from './configReducer'

export default combineReducers({
    notaria: notariaReducer,
    auth: auth,
    config: configReducer
})